module.exports = __webpack_public_path__ + "img/mini-crowdfunding.abbfcfc1.jpeg";